import { render, staticRenderFns } from "./SkillsEditor.vue?vue&type=template&id=27f622b4"
import script from "./SkillsEditor.vue?vue&type=script&lang=js"
export * from "./SkillsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports